namespace TabAurous.OMS {
    export interface LabourPriceListRow {
        PricelistId?: number;
        PriceCode?: string;
        PriceName?: string;
        PriceType?: number;
        FixedName?: string;
        Narration?: string;
        PriceListDetails?: LabourPriceListDetailsRow[];
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        Sys_Date?: string;
    }

    export namespace LabourPriceListRow {
        export const idProperty = 'PricelistId';
        export const nameProperty = 'PriceCode';
        export const localTextPrefix = 'OMS.LabourPriceList';
        export const lookupKey = 'OMS.LabourPriceList';

        export function getLookup(): Q.Lookup<LabourPriceListRow> {
            return Q.getLookup<LabourPriceListRow>('OMS.LabourPriceList');
        }
        export const deletePermission = 'Products:Delete';
        export const insertPermission = 'Products:Add';
        export const readPermission = '*';
        export const updatePermission = 'Products:Edit';

        export declare const enum Fields {
            PricelistId = "PricelistId",
            PriceCode = "PriceCode",
            PriceName = "PriceName",
            PriceType = "PriceType",
            FixedName = "FixedName",
            Narration = "Narration",
            PriceListDetails = "PriceListDetails",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            Sys_Date = "Sys_Date"
        }
    }
}
